import { jsxs as o, jsx as l } from "react/jsx-runtime";
import D from "react";
import { withManagedProps as E } from "@made-people/managed-props";
import { z as t } from "zod";
import { withZod as F } from "@made-people/react-prop-guard";
import { blogTeaserStyling as H } from "./index-blueprint.es.js";
import { responsiveImageSchema as M, ResponsiveImage as P } from "@made-people/blueprint-responsive-image";
import { useLink as V } from "@made-people/grease-link";
import "@made-people/blueprint";
const Z = t.custom().optional(), q = t.object({
  content: t.object({
    heading: t.string().optional(),
    tags: t.object({
      tag: t.string().optional()
    }).array().optional(),
    headingTag: t.union([t.literal("h2"), t.literal("h3"), t.literal("h4")]).default("h3").optional(),
    excerpt: t.string().optional(),
    image: M,
    badges: t.array(
      t.object({
        badge: t.string().optional()
      })
    ).optional(),
    link: t.object({
      href: t.string().optional()
    }).optional(),
    linkLabel: t.string().optional()
  }),
  blogReference: t.any().optional(),
  features: t.object({
    linkEntireCard: t.boolean().optional(),
    tagsSeparator: t.literal("dot").optional()
  }).optional(),
  variants: Z
}), Y = E(
  "BlogTeaser",
  F(
    q,
    ({
      blogReference: a,
      variants: W,
      content: s,
      features: { linkEntireCard: d, tagsSeparator: w } = {
        linkEntireCard: !0,
        tagsSeparator: "dot"
      }
    }) => {
      var n, k, j, u, N, y, L, x, T, v, S;
      const p = H.styles(W), g = V(), B = s.headingTag || "h3", I = d ? "span" : g, i = {
        ...s,
        heading: s.heading || typeof a == "object" && ((n = a == null ? void 0 : a.content) == null ? void 0 : n.heading),
        excerpt: s.excerpt || typeof a == "object" && ((k = a == null ? void 0 : a.content) == null ? void 0 : k.excerpt),
        tags: (j = s.tags) != null && j.length ? s.tags : typeof a == "object" && ((u = a == null ? void 0 : a.content) == null ? void 0 : u.tags),
        badges: (N = s.badges) != null && N.length ? s.badges : typeof a == "object" && ((y = a == null ? void 0 : a.content) == null ? void 0 : y.badges),
        link: typeof a == "object" && {
          href: a == null ? void 0 : a.slug
        },
        linkLabel: s.linkLabel || typeof a == "object" && ((L = a == null ? void 0 : a.content) == null ? void 0 : L.linkLabel)
      }, z = ({ children: r }) => {
        var m;
        if (i.link)
          return d && ((m = i.link) != null && m.href) ? /* @__PURE__ */ l(g, { className: p.base, href: i.link.href, children: r }) : /* @__PURE__ */ l("div", { className: p.base, children: r });
      }, h = s.image.image || (typeof a == "object" ? {
        src: (x = a == null ? void 0 : a.content) == null ? void 0 : x.image.src,
        alt: (T = a == null ? void 0 : a.content) == null ? void 0 : T.image.alt
      } : null);
      return /* @__PURE__ */ o(z, { children: [
        /* @__PURE__ */ o("div", { className: p.imageWrapper, children: [
          i.badges && /* @__PURE__ */ l("div", { className: p.badges, children: (v = i.badges) == null ? void 0 : v.map(
            ({
              badge: r
            }, m) => /* @__PURE__ */ l("span", { className: p.badge, children: r }, `${r}-${m}`)
          ) }),
          h && /* @__PURE__ */ l(
            P,
            {
              className: p.image,
              image: {
                src: h.src ?? "",
                alt: h.alt
              }
            }
          )
        ] }),
        /* @__PURE__ */ o("div", { className: p.contentWrapper, children: [
          i.tags && i.tags.length ? /* @__PURE__ */ l("ol", { className: p.tags, children: i.tags.map(
            ({
              tag: r
            }, m) => {
              var c, $;
              return /* @__PURE__ */ o(D.Fragment, { children: [
                /* @__PURE__ */ l("li", { className: p.tag, children: r }),
                ((c = s == null ? void 0 : s.tags) == null ? void 0 : c.length) && m < (($ = s == null ? void 0 : s.tags) == null ? void 0 : $.length) - 1 && w === "dot" && /* @__PURE__ */ l("li", { className: p.tagsSeparatorDot })
              ] }, `${r}-${m}`);
            }
          ) }) : null,
          i.heading && /* @__PURE__ */ l(B, { className: p.heading, children: i.heading }),
          i.excerpt && /* @__PURE__ */ l("p", { className: p.text, children: i.excerpt }),
          i.linkLabel && i.link && /* @__PURE__ */ l(
            I,
            {
              className: p.link,
              href: ((S = i == null ? void 0 : i.link) == null ? void 0 : S.href) ?? "",
              children: s.linkLabel
            }
          )
        ] })
      ] });
    }
  )
);
export {
  Y as BlogTeaser,
  q as blogTeaserSchema,
  Z as blogTeaserVariantsSchema
};
//# sourceMappingURL=index.es.js.map
